module.exports = __webpack_public_path__ + "img/tsp_materials.ea9474ea.png";